import { cn } from '@bazaar-marketplace/utils';
import { useTranslations } from 'next-intl';

import { SvgStickerCircle } from '@bazaar-marketplace/assets/sticker-circle';
import { openTelegramOrRegularLink } from '~/lib/open-link';
import { Button } from '../ui';

interface AddToCollectionButtonProps {
  telegramStickerSetUrl?: string | null;
  className?: string;
}

export const AddToCollectionButton = ({ telegramStickerSetUrl, className }: AddToCollectionButtonProps) => {
  const t = useTranslations('ui.button');
  const onAddToCollection = () => {
    if (telegramStickerSetUrl) {
      openTelegramOrRegularLink(telegramStickerSetUrl);
    }
  };

  // Only show button if telegram URL is available (pack is unwrapped)
  if (!telegramStickerSetUrl) {
    return null;
  }

  return (
    <Button className={cn('flex gap-2 text-[#23262E]', className)} variant="rainbow" onClick={onAddToCollection}>
      <SvgStickerCircle /> {t('save-pack')}
    </Button>
  );
};
